import { createApi } from '@reduxjs/toolkit/query/react';
import { ENDPOINT_CONSTANTS } from '../../constant';
import baseQueryWithReauth from 'service/baseQuery/baseQuery';

type ApiResponse<T> = {
  data: T;
  status: number;
  message?: string;
};

export const userQuery = createApi({
  reducerPath: 'userQuery',
  baseQuery: baseQueryWithReauth,
  endpoints: builder => ({
    findUserRoles: builder.query({
      query: () => ({
        url: ENDPOINT_CONSTANTS.USER_ROLE,
        method: 'GET'
      }),
      transformResponse: <T>(
        response: ApiResponse<T> | undefined
      ): T | undefined => {
        return response?.data;
      }
    })
  })
});

export const { useFindUserRolesQuery } = userQuery;
